import { HistoryMovement, Range } from 'types';

type GetHistoryMovementsProps = {
  validatedRanges: Range[];
  holdingClassName: string;
  partnerNameSeller: string;
  partnerNameBuyer: string;
  sharePrice: number;
};

export const getHistoryMovements = ({
  validatedRanges,
  holdingClassName,
  partnerNameSeller,
  partnerNameBuyer,
  sharePrice,
}: GetHistoryMovementsProps): HistoryMovement[] => {
  const historyMovements: HistoryMovement[] = [];

  validatedRanges.forEach((range: Range) => {
    historyMovements.push({
      from: range.from,
      to: range.to,
      holdingClassName: holdingClassName || '',
      partnerNameSeller,
      partnerNameBuyer,
      sharePrice,
    });
  });

  return historyMovements;
};
